import React from 'react';
import AnnouncementBanner from '../AnnouncementBanner';
import CookieBanner from '../CookieBanner';
import KVKKConsentModal from '../KVKKConsentModal';
import DesktopHeader from './DesktopHeader';
import MobileHeader from './MobileHeader';
import BottomNav from './BottomNav';
import LayoutFooter from './LayoutFooter';
import { useLayoutData } from './useLayoutData';

const Layout = ({ children }) => {
  const data = useLayoutData();

  return (
    <div className="min-h-screen bg-background">
      <AnnouncementBanner onHeightChange={data.setBannerHeight} />
      <DesktopHeader data={data} />
      <MobileHeader data={data} />

      <main
        className="pb-mobile-nav md:pb-0"
        style={{ paddingTop: `calc(${data.bannerHeight}px + 60px)` }}
      >
        {data.user?.is_deactivated && (
          <div className="bg-amber-500 text-white text-center text-xs py-1.5 px-4" data-testid="readonly-banner">
            This account has been closed. You are viewing in read-only mode. No actions can be performed.
          </div>
        )}
        {children}
      </main>

      <BottomNav data={data} />
      <LayoutFooter data={data} />
      <KVKKConsentModal user={data.user} />
      <CookieBanner />
    </div>
  );
};

export default Layout;
